import { Row, Col, Card, Button, Input, Form, Skeleton, Image, Select, Table, Tooltip, Tag, Modal, InputNumber } from "antd";
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useRequest from "../../../hooks/useRequest";
import { ShowToast, Severty } from "../../../helper/toast";
import apiPath from "../../../constants/apiPath";
import { Badge } from 'antd';
import moment from "moment";
import { PRICE } from "../../../constants/conts";
import notfound from "../../../assets/images/not_found.png";
import ShowTotal from "../../../components/ShowTotal";
import ConfirmationBox from "../../../components/ConfirmationBox";
import { ViewAttribute } from "./ViewAttribute";
import MultipleImageUpload from "../../../components/MultipleImageUpload";

function View() {

  const generateRandomSKU = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let sku = '';

    const randomNum = Math.floor(Math.random() * (15 - 4 + 1)) + 4;

    for (let i = 0; i < randomNum; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      sku += characters.charAt(randomIndex);
    }

    return sku;
  }


  const sectionName = "Product";
  const routeName = "product/catalogue";

  const api = {
    attrList: apiPath.listProduct,
    view: apiPath.viewProduct,
    categoryAttribute: apiPath.categoryAttribute,
    addAttribute: apiPath.addAttribute,
    status: apiPath.statusProduct,
  }

  const params = useParams();
  const [form] = Form.useForm()
  const [categoryAttribute, setCategoryAttribute] = useState([]);
  const [attrLoading, setAttrLoading] = useState(false)
  const { request } = useRequest();
  const [list, setList] = useState();
  const [loading, setLoading] = useState(false);
  const { showConfirm } = ConfirmationBox()
  const [attrList, setAttrList] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [visible, setVisible] = useState(false);
  const [imageUpload, showImageUpload] = useState(false);
  const [selected, setSelected] = useState();
  const [selectedAttribute, setSelectedAttribute] = useState([]);
  const [skuu, setSku] = useState(() => generateRandomSKU());

  const viewAttribute = (id) => {
    if (id) {
      setVisible(true)
    }
  };

  const fetchData = (id) => {
    request({
      url: api.view + "/" + id,
      method: 'GET',
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data);
        getCategoryAttributeList(data && data.data && data.data.category_id && data.data.category_id._id)
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  const getCategoryAttributeList = (category_id) => {
    const payload = {}
    payload.category_id = category_id;
    request({
      url: api.categoryAttribute,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setCategoryAttribute(data.data.data);
      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  };


  const OnAttributeUpdate = (values) => {

    if (selectedAttribute.length === 0) return ShowToast('At least one attribute must be selected', Severty.INFO)

    const imageRequire = selectedAttribute.find(({ is_image_require }) => is_image_require)

    if (imageRequire) {
      return showImageUpload(true)
    }

    onUpdate()
  };

  const onUpdate = (images) => {
    let img = Array.isArray(images) ? [...list?.image, ...images] : list?.image;

    console.log(img)
    const { sku, price } = form.getFieldsValue()
    const payload = { sku: sku ?? skuu, price };
    payload.product_id = params.id;
    payload.attribute = selectedAttribute;
    payload.images = img;
    setAttrLoading(true)
    request({
      url: api.addAttribute,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setAttrLoading(false)
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS)
          setRefresh(prev => !prev)
          form.resetFields()
        } else {
          ShowToast(data.message, Severty.ERROR)
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR)
        setAttrLoading(false)
      },
    })
  }

  const OnSelect = (value, item, index) => {

    const newArray = [...selectedAttribute]
    newArray[index] = {
      name: item.name,
      type: item.type,
      value,
      is_image_require: item.is_image_require
    }
    setSelectedAttribute(newArray)
    console.log(value, item, index, newArray)
  }

  const columns = [
    {
      title: "Thumbnail",
      dataIndex: "thumbnail",
      key: "thumbnail",
      render: (_, { thumbnail, image }) => <Image width={50} src={thumbnail ? thumbnail : image ? image[0] : notfound} />
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, { name }) => {
        return name ? <span className="cap">{name}</span> : '-';
      },
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "name",
      render: (_, { sku }) => {
        return sku ? <span className="cap">{sku}</span> : '-';
      },
    },
    {
      title: "Price (" + PRICE + ")",
      dataIndex: "price",
      key: "price",
      render: (_, { price }) => {
        return price ? <span className="cap">{price}</span> : '-';
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 500,
      render: (_, { type_id }) => {
        return type_id && type_id.name ? <span className="cap">{type_id.name}</span> : '-';
      },
    },
    {
      title: "Make",
      dataIndex: "make_id",
      key: "make_id",
      width: 500,
      render: (_, { make_id }) => {
        return make_id && make_id.name ? <span className="cap">{make_id.name}</span> : '-';
      },
    },
    {
      title: "Model",
      dataIndex: "model",
      key: "model",
      width: 500,
      render: (_, { model_id }) => {
        return model_id && model_id.name ? <span className="cap">{model_id.name}</span> : '-';
      },
    },
    {
      title: "Variant",
      dataIndex: "variant",
      key: "variant",
      width: 500,
      render: (_, { variant_id }) => {
        return variant_id && variant_id.name ? <span className="cap">{variant_id.name}</span> : '-';
      },
    },
    /* {
      title: "Brand",
      dataIndex: "brand",
      key: "brand",
      render: (_, { brand }) => {
        return brand && brand.name ? <span className="cap">{brand.name}</span> : '-';
      },
    }, */
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      render: (_, { category }) => {
        return category && category.name ? <span className="cap">{category.name}</span> : '-';
      },
    },
    {
      title: "Attributes",
      dataIndex: "attribute_value",
      key: "attribute_value",
      render: (_, { attribute }) => {
        return attribute ? <span className="cap">{attribute.map(item => <p>{`${item.name} => ${item.value}`}</p>)}</span> : '-';
      },
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      render: (_, { is_active, _id }) => {
        let color = is_active ? 'green' : 'red';
        return (<a><Tag onClick={(e) => showConfirm({ record: _id, path: api.status, onLoading: () => setAttrLoading(true), onSuccess: () => setRefresh(prev => !prev) })} color={color} key={is_active}>{is_active ? "Active" : "Inactive"}</Tag></a>);
      },
    },
    {
      title: "Created On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return (
          moment(created_at).format('DD-MMM-YYYY')
        );
      },
    },
    {
      title: "Action",
      fixed: 'right',
      render: (_, record) => {
        return (
          <Tooltip title={"View " + sectionName} color={"purple"} key={"view" + routeName}><Button title="View" onClick={(e) => { setSelected(record); viewAttribute(record._id); }}><i className="fa fa-light fa-eye"></i></Button></Tooltip>
        );
      },
    },
  ];

  const fetchAttributeData = () => {
    request({
      url: api.attrList + `?product_id=${params.id}`,
      method: 'GET',
      onSuccess: (data) => {
        setAttrLoading(false)
        setAttrList(data.data.list?.docs)
        setPagination(prev => ({ current: 1, total: data.data.list.totalDocs }))
      },
      onError: (error) => {
        console.log(error)
        ShowToast(error, Severty.ERROR)
      }
    })
  }

  useEffect(() => {
    fetchAttributeData();
  }, [refresh])

  useEffect(() => {
    setLoading(true)
    fetchData(params.id)
  }, [])

  return (
    <>
      <Row gutter={[16, 16]}>

        <Col span={24} xxl={16}>
          <Card title={sectionName + " Details"} style={{ height: "100%" }}>
            <Row gutter={16}>
              <Col span={12} xs={24} md={24}>

                {loading ? [1, 2, 3, 4].map(item => <Skeleton active key={item} />) :
                  <div className="view-main-list">

                    <div className="view-inner-cls">
                      <h5>Thumbnail:</h5>
                      <h6><Image width={60} src={list?.thumbnail ? list?.thumbnail : notfound} /></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Name:</h5>
                      <h6><span className="cap">{list?.name ? list?.name : '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Sku:</h5>
                      <h6><span className="cap">{list?.sku ? list?.sku : '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Type:</h5>
                      <h6><span className="cap">{list?.type_id && list?.type_id.name ? list?.type_id.name : '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Make:</h5>
                      <h6><span className="cap">{list?.make_id && list?.make_id.name ? list?.make_id.name : '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Model:</h5>
                      <h6><span className="cap">{list?.model_id && list?.model_id.name ? list?.model_id.name : '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Variant:</h5>
                      <h6><span className="cap">{list?.variant_id && list?.variant_id.name ? list?.variant_id.name : '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Model Year:</h5>
                      <h6><span className="cap">{list?.year_model || '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Category:</h5>
                      <h6><span className="cap">{list?.category_id && list?.category_id.name ? list?.category_id.name : '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Part Number:</h5>
                      <h6><span className="cap">{list?.part_number ? list?.part_number : '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Description:</h5>
                      <h6>{list?.description ? <p dangerouslySetInnerHTML={{ __html: list?.description }}></p> : "-"}</h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Added By:</h5>
                      <h6><span className="cap">{list?.added_by || '-'}</span></h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Featured:</h5>
                      <h6>{list?.is_featured ? <Badge status="success" text="Yes" /> : <Badge status="error" text="No" />}</h6>
                    </div>

                    <div className="view-inner-cls">
                      <h5>Status:</h5>
                      <h6>{list?.is_active ? <Badge status="success" text="Active" /> : <Badge status="error" text="InActive" />}</h6>
                    </div>

                    {list && list?.image?.length > 0 ? <div className="view-inner-cls other-image productDetail">
                      <h5>Other Images:</h5>
                      <div className="other-img-inr">
                        {list?.image.map((item, index) =>
                          <div key={index} className="imageradius mt-1"><Image width={60} src={item} /></div>
                        )}
                      </div>
                    </div> : null}

                    {list && list?.parent_id != null ?
                      <div className="view-inner-cls">
                        <h5>Attribute Combination:</h5>
                        <Row className="text-right">
                          <Col span={24}>
                            {list && list?.attribute && list?.attribute.length > 0 && list?.attribute.map((item, index) =>
                              <h6 className="cap mt-1">{index + 1}) {item.name} : {item.value} &nbsp;</h6>
                            )}
                          </Col>
                        </Row>
                      </div>
                      : null}

                    <div className="view-inner-cls">
                      <h5>Created On:</h5>
                      <h6>{list?.created_at ? moment(list?.created_at).format('DD-MMM-YYYY') : '-'}</h6>
                    </div>

                    <div className="view-inner-cls float-right">
                      <Link className="ant-btn ant-btn-primary" to={`/pimptup-admin/${routeName}`}>Back</Link>
                    </div>

                  </div>
                }
              </Col>
            </Row>
          </Card>
        </Col>

        {categoryAttribute && categoryAttribute.length > 0 ?
          <Col span={24} xxl={8}>
            <Card className="attributeCard" size="small" title="Attributes Details" style={{ height: "100%" }}>
              {loading ? [1, 2, 3].map(item => <Skeleton active key={item} />) :
                <Form
                  form={form}
                  className="edit-page-wrap"
                  onFinish={OnAttributeUpdate}
                  autoComplete="off"
                  layout="verticle"
                  name="attribute_form"
                  initialValues={{ sku: skuu, price: list?.price }}
                  style={{ height: "100%" }}>
                  <div className="scrollable-card">
                    <Row gutter={[0]}>
                      <Col span={24} xs={24} sm={24} md={24}>
                        <Form.Item
                          normalize={value => value.trimStart()} label="Sku" name="sku"
                          rules={[{ required: true, message: "Missing the sku!" },
                          { max: 15, message: "Name must contain minimum 4 and maximum 15 characters " },
                          { min: 4, message: "Name must contain minimum 4 and maximum 15 characters " }
                          ]}>
                          <Input defaultValue={skuu} onChange={(e) => setSku(e.target.value)} autoComplete="off" placeholder="Enter Product SKU" />
                        </Form.Item>

                        <Form.Item label={`Price (${PRICE})`} className="attribute-elt" name={`price`}
                          rules={[{ required: true, message: "Missing the price!" }]}
                        >
                          <InputNumber defaultValue={list?.price} type="number" maxLength={10} placeholder={`Enter product variation Price (${PRICE})`} />
                        </Form.Item>

                      </Col>
                      {categoryAttribute.length > 0 ? categoryAttribute.map((item, index) => (
                        <Col span={24} xs={24} sm={24} md={24}>

                          <Form.Item hidden className="attribute-elt" name={`attribute_id_${item.name}`}>
                            <Input defaultValue={item.name}></Input>
                          </Form.Item>

                          <Form.Item
                            className="attribute-elt"
                            name={`attribute_value_${item.name}`}
                            rules={[{
                              required: item.is_mandatory, message: `${item.name} is required`
                            }]}
                            label={<span className="cap">{item.name}</span>}
                          >
                            <Select
                              placeholder={<span className="cap">{`Select ${item.name} Attribute`}</span>}
                              onChange={(value) => OnSelect(value, item, index)}
                            >
                              {item.options && item.options.length > 0 ? item.options.map(({ value }, key) => (
                                <option key={key} value={value}>
                                  <span className="cap">{value}</span>
                                </option>
                              )) : null}
                            </Select>

                          </Form.Item>
                        </Col>
                      )) : null}
                    </Row>
                  </div>

                  <Form.Item className="btn-row">
                    <Button type="primary mt-1" loading={attrLoading} htmlType="submit">Submit Variant</Button>
                  </Form.Item>
                </Form>
              }
            </Card>
          </Col>
          : null}
      </Row>

      <Card className="mt-3" title="Product Variention(s)">
        <div className="tabled">
          <Row gutter={[24, 0]}>
            <Col xs="24" xl={24}>
              <h4 className="text-right mb-1">{pagination.total ? ShowTotal(pagination.total) : ShowTotal(0)}</h4>
              <div className="table-responsive customPagination">
                <Table
                  loading={attrLoading}
                  columns={columns}
                  dataSource={attrList}
                  pagination={{ defaultPageSize: 10, responsive: true, total: pagination.total, showSizeChanger: true, pageSizeOptions: ['10', '20', '30', '50'] }}
                  className="ant-border-space"
                />
              </div>
            </Col>
          </Row>
        </div>
      </Card>

      {visible && <ViewAttribute show={visible} hide={() => { setVisible(false) }} data={selected} />}
      {imageUpload &&
        <ImageUpload
          show={imageUpload}
          hide={() => { showImageUpload(false) }}
          onUpdate={onUpdate}
        />
      }

    </>
  );
}

const FileType = ["image/png", "image/jpg", "image/jpeg", "image/avif", "image/webp", "image/gif"]

const ImageUpload = ({ show, hide, onUpdate }) => {
  const [multipleImage, setMultipleImage] = useState([]);

  const handleMultipleImage = (data) => {
    setMultipleImage(data);
  }

  const onOk = () => {
    if (!multipleImage.length) return ShowToast('At least one image require', Severty.ERROR)

    onUpdate(multipleImage.map((item) => item.url))
    hide()
  }

  return (
    <Modal
      width={600}
      open={show}
      title={`Image Upload`}
      okText="Submit"
      onCancel={hide}
      okButtonProps={{
        onClick: onOk
      }}
    >
      <div className="mt-1">
        <MultipleImageUpload
          fileType={FileType}
          imageType={'product'}
          btnName={'Image'}
          onChange={(data) => handleMultipleImage(data)} />
      </div>
    </Modal>
  )
}

export default View;